import React, {useEffect, useRef} from 'react';
import {GridToolbar} from '@mui/x-data-grid-pro';

/**
 * Drop-in for GridToolbar with the quick filter always on, focused on mount, and refocused
 * when typing starts anywhere on the page.
 *
 * Search matches hidden columns too — the quick filter works on row values, not on what is
 * rendered.
 */
const IyoGridToolbar = (props) => {
  const toolbarRef = useRef(null);

  useEffect(() => {
    const findInput = () =>
      toolbarRef.current?.querySelector('.MuiDataGrid-toolbarQuickFilter input');

    const handleKeyDown = (event) => {
      // Printable characters only; Escape, Tab and arrows belong to the grid.
      if (event.metaKey || event.ctrlKey || event.altKey) return;
      if (event.key.length !== 1) return;

      const active = document.activeElement;
      if (!active) return;
      if (active.isContentEditable) return;
      if (['INPUT', 'TEXTAREA', 'SELECT'].includes(active.tagName)) return;

      // Focus during keydown, not keyup, so this keystroke lands in the field.
      findInput()?.focus();
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <GridToolbar
      {...props}
      ref={toolbarRef}
      showQuickFilter
      quickFilterProps={{autoFocus: true, placeholder: 'Search…', ...props.quickFilterProps}}
    />
  );
};

export default IyoGridToolbar;
